import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SigninEventEvaluationService {
  private http = inject(HttpClient);

  getAttendeeQuestions(
    urlParams: { company_id: string | number; event_id: string | number },
    apiParams: Record<string, any> = {}
  ): Observable<any[]> {
    const url = `${environment.apiUrl}/api/companies/${urlParams.company_id}/events/${urlParams.event_id}/evaluations/attendee_anonymous`;
    return this.http.get<any[]>(url, { params: this.toHttpParams(apiParams) });
  }

  submitAnonymousAnswers(
    body: { token: string; answers: Record<string | number, any> },
    urlParams: { company_id: string | number; event_id: string | number }
  ): Observable<any> {
    const url = `${environment.apiUrl}/api/companies/${urlParams.company_id}/events/${urlParams.event_id}/attendee_answer_anonymouses`;
    return this.http.post<any>(url, body);
  }

  private toHttpParams(obj: Record<string, any>): HttpParams {
    let params = new HttpParams();
    for (const key of Object.keys(obj)) {
      const val = obj[key];
      if (val !== null && val !== undefined && val !== '') {
        params = params.append(key, String(val));
      }
    }
    return params;
  }
}
